import { Input } from "components/shadcn/input";
import { CircleAlert, Eye, EyeOff } from "lucide-react";
import React, { ForwardedRef, useState } from "react";

const TextInputField = React.forwardRef(
    (
        {
            type,
            title,
            placeholder,
            errorMsg,
            preventWhiteSpace = false,
            ...props
        }: {
            type: string;
            title: string;
            placeholder: string;
            errorMsg?: string;
            preventWhiteSpace?: boolean;
        },
        ref: ForwardedRef<HTMLInputElement>,
    ) => {
        const [showPassword, setShowPassword] = useState(false);
        const isPasswordField = type === "password";

        const handlePasswordToggle = (e: React.MouseEvent) => {
            e.preventDefault();
            setShowPassword(!showPassword);
        };

        return (
            <div>
                <label htmlFor={title} className="block text-sm font-medium text-gray-600 dark:text-white mt-1">
                    {title}
                </label>
                <div className="relative">
                    <Input
                        type={isPasswordField && showPassword ? "text" : type}
                        id={title}
                        ref={ref}
                        {...props}
                        className="mt-1 hover:border-black focus:border-black dark:text-white pr-10"
                        placeholder={placeholder}
                        onKeyDown={(event) => {
                            if (preventWhiteSpace && event.key.match(/\s/)) {
                                event.preventDefault();
                            }
                        }}
                    />
                    {isPasswordField && (
                        <button
                            type="button"
                            onClick={handlePasswordToggle}
                            onMouseDown={(e) => e.preventDefault()}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                            aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                    )}
                </div>
                {errorMsg && (
                    <span className="text-sm text-red-400 flex items-center mt-1">
                        <CircleAlert className="inline-block mr-1" size={16} />
                        {errorMsg}
                    </span>
                )}
            </div>
        );
    },
);

TextInputField.displayName = "TextInputField";
export default TextInputField;